import type {SimpleStream} from '../../../../utils/simpleStream'
import createSimpleStream from '../../../../utils/simpleStream'

export const updateQueue$: SimpleStream<void> = createSimpleStream()
export const updateQueue: () => unknown = () => updateQueue$.fire()
